/**
 * <s-image-guard> blocks the browser's right-click menu and dragging on images
 * across the page, so visitors can't use "Save image as" or drag a photo out.
 * Wrap an image in [data-image-guard-allow] to exempt it (used for the free colouring page).
 * Rendered once in the layout when the theme's image protection setting is on.
 */
class ImageGuardElement extends HTMLElement {
  #controller = null;

  connectedCallback() {
    this.#controller = new AbortController();
    const { signal } = this.#controller;
    // Images inside [data-image-guard-allow] (the free colouring page) stay saveable.
    const isImage = (target) =>
      target instanceof Element &&
      Boolean(target.closest('img, picture, svg image, [data-watermark]')) &&
      !target.closest('[data-image-guard-allow]');
    const block = (event) => {
      if (isImage(event.target)) event.preventDefault();
    };
    document.addEventListener('contextmenu', block, { signal });
    document.addEventListener('dragstart', block, { signal });
  }

  disconnectedCallback() {
    this.#controller?.abort();
    this.#controller = null;
  }
}

if (!customElements.get('s-image-guard')) {
  customElements.define('s-image-guard', ImageGuardElement);
}
